import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';

export const cacStateOptions = [
  { text: 'Active', value: 'UNBLOCK' },
  { text: 'Blocked', value: 'BLOCK' },
  { text: 'Blocked for Incoming', value: 'BLOCK_INCOMING' },
  { text: 'Blocked for Outgoing', value: 'BLOCK_OUTGOING' },
];

@Component({
  selector: 'offline-pcons-dialog',
  templateUrl: './offline-pcons-dialog.component.html',
  styleUrls: ['./offline-pcons-dialog.component.scss']
})
export class OfflinePconsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OfflinePconsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private userPrivilege: UserPrivilegeService) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  advancedConditions: any;
  useGlobalAdvancedCondition;
  formValid = true;
  cacStateOptions = cacStateOptions;
  isAuthorized: boolean;

  pConsOperStateOptions = [
    {text: 'AVAILABLE', value: 'AVAILABLE'},
    {text: 'UNAVAILABLE', value: 'UNAVAILABLE'},
    {text: 'PREDELETED', value: 'PREDELETED'}
  ];

  qualityOptions = [
    {text: 'UNKNOWN', value: 'UNKNOWN'},
    {text: 'BAD', value: 'BAD'},
    {text: 'FAIR', value: 'FAIR'},
    {text: 'GOOD', value: 'GOOD'}
  ];

  pConNodeTypesOptions = [{text: 'IPGroup', value: 'IPGroup'}, {text: 'TrunkGroup', value: 'TrunkGroup'}];

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();

    if (!this.data.isEditMode) {
      if (this.data.rIs.length > 0){
        this.data.selectedItem.riId = this.data.rIs[0].id;
      }
      this.data.selectedItem.operState = 'AVAILABLE';
      this.data.selectedItem.result = 'UNKNOWN';
    }
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }

  checkFormValid(): void {
    if (this.data.selectedItem.voipPeerId === null) {
      this.formValid = false;
    } else {
      this.formValid = true;
    }
  }
}
